<template>
  <div id="lm-component-loading" :style="position">
    <img src="@/assets/images/LmComponentLoading.svg" alt="loading" />
  </div>
</template>

<script>
export default {
  props: {
    top: Number,
    left: Number,
    right: Number,
    bottom: Number
  },
  computed: {
    position: function () {
      let measure = 'px'
      let style = ''
      if (this.top) {
        style += `top:${this.top}${measure}`
      }
      if (this.left) {
        style += `left:${this.left}${measure}`
      }
      if (this.right) {
        style += `right:${this.right}${measure}`
      }
      if (this.bottom) {
        style += `bottom:${this.bottom}${measure}`
      }
      return style
    }
  }
}
</script>

<style lang="sass" scoped>
  #lm-component-loading
    background: white
    position: absolute
    z-index: 1
    top: 0
    left: 0
    right: 0
    bottom: 0
    margin: auto
    img
      position: absolute
      z-index: 1
      top: 0
      left: 0
      right: 0
      bottom: 0
      margin: auto
      fill: $primaryThemeColor
</style>
